
seedWebServices.service('LogisticsService', ['$http', '$cacheFactory', '$uibModal', 'TranslationService',
    function ($http, $cacheFactory, $uibModal, TranslationService) {
        var serviceCache = $cacheFactory('LogisticsService');

        var URL = '../Api/Logistics/';

        this.resetCache = function () {
            serviceCache.removeAll();
        };

        this.getOrders = function (filterString, options, skipNumber, takeNumber, sort, parentFilter) {
            return $http.put(URL + '/SearchOrders', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, parentFilter: parentFilter }, { cache: serviceCache });
        };


        this.getOrder = function (id) {
            var cache = serviceCache;
            return $http.get(URL + 'GetOrder', {
                params: { id: id },
                cache: cache
            });
        };

        this.getOrdersColumns = function (column, filterString, skipSize, takeSize, parentFilter, searchString, options) {
            return $http.put(URL + '/GetOrdersColumns',
                {
                    column: column,
                    filterString: filterString,
                    skipSize: skipSize,
                    takeSize: takeSize,
                    parentFilter: parentFilter,
                    searchString: searchString,
                    options: options
                },
                { cache: serviceCache }
            );          
        };

        this.getEmailsByDocument = function () {
            var cache = serviceCache;
            return $http.get(URL + 'GetEmailsByDocument', {
                params: {},
                cache: cache
            });
        };

        this.fillEmail = function (email, orders) {
            return $http.put(URL + '/FillEmail',
                {
                    email: email,
                    orders: orders,                    
                }
            ); 
        };

        this.sendEmail = function (email, orders) {
            return $http.put(URL + '/SendEmail',
                {
                    email: email,
                    orders: orders,
                }
            );
        };

        this.getSentEmails = function (filterString, options, skipNumber, takeNumber, sort, parentFilter) {
            return $http.put(URL + '/GetSentEmails', { filterString: filterString, options: options, skipNumber: skipNumber, takeNumber: takeNumber, sort: sort, parentFilter: parentFilter }, { cache: serviceCache });
        };

        this.getSentEmail = function (id) {
            var cache = serviceCache;
            return $http.get(URL + 'GetSentEmail', {
                params: { sentEmailID: id },
                cache: cache
            });
        };

        this.getSentEmailsColumns = function (column, filterString, skipSize, takeSize, parentFilter, searchString, options) {
            return $http.put(URL + 'GetSentEmailsColumns',
                {
                    column: column,
                    filterString: filterString,
                    skipSize: skipSize,
                    takeSize: takeSize,
                    parentFilter: parentFilter,
                    searchString: searchString,
                    options: options
                },
                { cache: serviceCache }
            );
        };

        this.getEmailsCounts = function (parentFilter) {
            return $http.put(URL + 'GetEmailsCounts',
                parentFilter,
                { cache: serviceCache }
            );
        };
           

    }
]);